// Internal
import appTypes from 'shared/utils/actions';
import { SUCCESS, FAILURE } from 'shared/constants/actions';

const records = appTypes.defineAction('records');

export const INITIALIZED = records.defineAction('INITIALIZED').toString();
export const SET_PATIENT = records.defineAction('SET_PATIENT').toString();
export const ENDED = records.defineAction('ENDED').toString();
export const CHANGED_TAB = records.defineAction('CHANGED_TAB').toString();
export const AUTO_SAVE = records.defineAction('AUTO_SAVE').toString();
export const GET_EVENT_BLOCKS_IDS = records.defineAction(
  'GET_EVENT_BLOCKS_IDS',
  [SUCCESS, FAILURE],
);
export const GET_LATEST_DIAGNOSES = records.defineAction(
  'GET_LATEST_DIAGNOSES',
  [SUCCESS, FAILURE],
);

export const GET_PATIENT_HEADER = records.defineAction('GET_PATIENT_HEADER', [
  SUCCESS,
  FAILURE,
]);

export const TOOGLE_PATIENT_HEADER_MODAL = 'TOOGLE_PATIENT_HEADER_MODAL';

export const SHOW_PRESCRIPTION_TAB = 'SHOW_PRESCRIPTION_TAB';

export const pdfUrls = {
  prescription: '/prescriptions/prescription/',
  attest: '/attests/attest/',
  ophthalmic: '/records/eventblock/',
  exam_request: '/exams/examrequest/pdf/private/',
  budget: '/records/eventblock/',
};

export const documentsKind = {
  ophthalmic: 'ophthalmic',
  prescription: 'prescription',
  attest: 'attest',
  exam_request: 'exam_request',
  budget: 'budget',
};

export type GetPatientHeaderRelativesResponse = {
  related_patient_name: string;
  relatedness: string;
};

export type GetPatientHeaderResponse = {
  age: string;
  civil_name: string;
  email: string;
  first_appointment: string;
  insurance_name: string;
  mobile_phone: string;
  home_phone: string;
  name: string;
  url_image: string;
  patient_related: Array<GetPatientHeaderRelativesResponse>;
};

export type PatientRelative = {
  relatedPatientName: string;
  relatedness: string;
};
export type PatientSummary = {
  name: string;
  civilName: string;
  email: string;
  age: string;
  mobilePhone: string;
  homePhone: string;
  firstAppointment: string;
  insuranceName: string;
  patientRelated: PatientRelative[];
  urlImage: string;
};
